import {
    CreateEmployeePerformanceInput,
    CreateHrPerformanceInput,
    CreateManagerPerformanceInput
} from './interface';

export class GetAllPerformance {
    static readonly type = '[Performance] all for manager';
    constructor(public managerId: string) {}
}
export class GetSinglePerformanceByManager {
    static readonly type = '[Performance] single for managers';
    constructor(public input: { id: string; managerFormId?: string }) {}
}
export class GetAllPerformanceManagerByEmployee {
    static readonly type = '[Performance] all request for employee';
    constructor(public input: { managerId: string; userId: string }) {}
}
export class GetSingleManagerPerformanceByEmployee {
    static readonly type = '[Performance] single for manager';
    constructor(public input: { id: string; employeeFormId?: string }) {}
}
export class GetAllPerformanceEmployeeByManager {
    static readonly type = '[Performance]  all employee request by manager';
    constructor(public managerId: string) {}
}

export class GetSinglePerformanceEmployeeByManager {
    static readonly type = '[Performance] single employee by manager';
    constructor(public id: string) {}
}

export class SendHrPerformanceData {
    static readonly type = '[Performance] hr';
    constructor(public input: CreateHrPerformanceInput) {}
}

export class SendManagerPerformanceData {
    static readonly type = '[Performance] manager';
    constructor(public input: CreateManagerPerformanceInput) {}
}

export class ClearLoading {
    static readonly type = '[Performance] loading';
}

export class CreateEmployeePerformanceData {
    static readonly type = '[Performance] employee';
    constructor(public input: CreateEmployeePerformanceInput) {}
}

export class UpdateManagerPerformanceData {
    static readonly type = '[Performance] update';
    constructor(public input: CreateManagerPerformanceInput) {}
}

export class UploadSignature {
    static readonly type = '[Performance] sigature upload';
    constructor(
        public input: {
            employeeName: string;
            signatureUrl: string;
        }
    ) {}
}
